var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"newsletter-type-subscriber-create"}},[_c('h2',[_vm._v("\n    Create Newsletter Type Subscriber\n  ")]),_vm._v(" "),_c('newsletter-type-nav',{attrs:{"newsletterTypeId":_vm.newsletterTypeId}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('newsletter-type-subscriber-form',{attrs:{"newsletterTypeId":_vm.newsletterTypeId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-da4438da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterTypeSubscriberCreate.vue
// module id = 1287
// module chunks = 1